<template>
  <div class="home">
    <ComicReader @bannerType="setBannerType"></ComicReader>
  </div>
</template>

<script>
import ComicReader from '@/components/ComicReader'

export default {

  name: 'Home',
  components: {
    ComicReader,
  },
  methods: {
    setBannerType(value){
      this.$emit("bannerType", value);
    }
  },
}
</script>